import { Injectable } from '@angular/core';
import { AvisInitialService } from '../avis-initial/avis-initial.service';
import { DescriptionService } from '../description/description.service';
import { InfosRectifService } from '../infos-rectif/infos-rectif.service';
import { ProcedureService } from '../procedure/procedure.service';

@Injectable({
  providedIn: 'root'
})
export class FormmapaRectificatifServices {

  constructor(public descriptionService: DescriptionService, public infosRectifService: InfosRectifService, public avisInitialService: AvisInitialService,
    public procedureService: ProcedureService) { }
}
